import { XMarkIcon } from '@heroicons/react/24/outline';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableImageTile({ img, isFirst, disabled, onRemove }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: img.id,
    disabled,
  });
  const src = img.kind === 'existing' ? img.url : img.previewUrl;
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`relative h-40 rounded-lg overflow-hidden touch-none
        ${disabled ? '' : 'cursor-grab active:cursor-grabbing'}
        ${isDragging ? 'opacity-40 z-10' : ''}`}
    >
      <img src={src} alt="" className="h-full w-auto rounded-lg pointer-events-none" />
      {isFirst && (
        <span className="absolute bottom-1 left-1 rounded bg-black/40 text-white text-[10px] px-1.5 py-0.5">
          Cover
        </span>
      )}
      <button
        type="button"
        onPointerDown={e => e.stopPropagation()}
        onClick={() => onRemove(img.id)}
        aria-label="Remove image"
        className="absolute top-1 right-1 rounded-full bg-black/40 hover:bg-black/60 text-white p-1 transition focus:outline-none"
      >
        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}

export default SortableImageTile;
